module.exports = __webpack_public_path__ + "img/mz.5f6a88d7.svg";